import React from "react";
import { NavLink } from "react-router-dom";
import "./CommunityNavBar.css";

const CommunityNavBar = () => {
  return (
    <div className="CommunityNavBar">
      {/* Sidebar Menu */}
      <div className="CommunitySidebar">
        <ul className="communitySidebarMenu">
          {/* Main Links */}
          <li className="communitySidebar-item">
            <NavLink to="/community-home" activeClassName="active">
              Community Home
            </NavLink>
          </li>
          <li className="communitySidebar-item">
            <NavLink to="/community-page" activeClassName="active">
              Community Page
            </NavLink>
          </li>
          <li className="communitySidebar-item">
            <NavLink to="/my-room" activeClassName="active">
              My Room
            </NavLink>
          </li>
          <hr className="communitySidebar-divider" />

          {/* Section 2 */}
          <li className="communitySidebar-item">
            <NavLink to="/leaderboard" activeClassName="active">
              Leaderboard
            </NavLink>
          </li>
          <li className="communitySidebar-item">
            <NavLink to="/games" activeClassName="active">
              GAMES
            </NavLink>
          </li>
          <hr className="communitySidebar-divider" />

          {/* Section 3: Community Rooms */}
          <li className="communitySidebar-title">COMMUNITY ROOMS</li>
          <li className="communitySidebar-item community-room">
            <a href="/room1">Room 1</a>
          </li>
          <li className="communitySidebar-item community-room">
            <a href="/room2">Room 2</a>
          </li>
          <li className="communitySidebar-item community-room">
            <a href="/room3">Room 3</a>
          </li>
          <li className="communitySidebar-item community-room">
            <a href="/room4">Room 4</a>
          </li>
          <li className="communitySidebar-item community-room">
            <a href="/room5">Room 5</a>
          </li>
          <li className="communitySidebar-create-room">
            <NavLink to="/create-room">
              <i className="fa fa-plus-circle"></i> Create Room
            </NavLink>
          </li>
          <hr className="communitySidebar-divider" />

          {/* Section 4 */}
          <div className="communitySidebar-section4">
            <li className="communitySidebar-item">
              <NavLink to="/about" activeClassName="active">
                About .....
              </NavLink>
            </li>
            <li className="communitySidebar-item">
              <NavLink to="/advertise" activeClassName="active">
                Advertise
              </NavLink>
            </li>
            <li className="communitySidebar-item">
              <NavLink to="/help" activeClassName="active">
                Help
              </NavLink>
            </li>
            <li className="communitySidebar-item">
              <NavLink to="/blog" activeClassName="active">
                Blog
              </NavLink>
            </li>
          </div>
        </ul>
      </div>
    </div>
  );
};

export default CommunityNavBar;
